import React, { ReactNode } from 'react';

import * as styles from './screen-readers-page-title.scss';

export const ScreenReadersPageTitle = ({ children }: { children: ReactNode }) => {
  return <h1 className={styles.visuallyHidden}>{children}</h1>;
};
